import { Outlet } from 'react-router-dom';
import { NavBar, Sidebar } from '../../components';
import { useCallSocketEvents, useIntercom } from '../../hooks';
import Banners from './Banners';
import Modals from './Modals';

function MainLayout() {
  useIntercom();
  // Listens on call events and updates call details accordingly.
  useCallSocketEvents();

  return (
    <div className="flex h-screen flex-col">
      <Banners />
      <NavBar />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar />
        <div className="min-w-0 flex-1 bg-base-200">
          <Outlet />
        </div>
      </div>
      <Modals />
    </div>
  );
}

export default MainLayout;
